import { STATUS, MAIL_STATUS } from '../../../utils/constants';
import { swalClose, swalShowProgress } from '../../../helpers/swalHelper';
import NotifyListApi from '../../../service/notify.api';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper, Stack,
  Table, Typography,
} from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import { useCallback } from 'react';

export default function EmailConfirmDialog({ open, onClose, rowSelectedList, setSendMailStatus }) {
  const postBatchApi = async (dataArray) => {
    const batchSize = 10
    const allResponses = []
    const totalMail = dataArray.length
    let completed = 0

    swalShowProgress(totalMail, 'ระบบกำลังส่งอีเมล...')

    for (let i = 0; i < totalMail; i += batchSize) {
      const batch = dataArray.slice(i, i + batchSize)

      try {
        const response = await NotifyListApi.postSendMailApi(batch)

        allResponses.push(response)
      } catch (error) {
        console.error(`Error on batch ${i / batchSize + 1}`, error)
      }

      completed += batch.length
      const progressEl = document.getElementById('email-progress')
      const progressText = document.getElementById('progress-text')

      if (progressEl) progressEl.value = completed
      if (progressText) progressText.innerText = `${completed} / ${totalMail}`
    }

    return allResponses.flat() // ถ้าแต่ละ response เป็น array แล้วอยากรวมทั้งหมด
  }

  const confirmSendMail = async (selectedMailList) => {
    const filteredMail = selectedMailList.filter((selectedMail) => {
      return selectedMail.email && selectedMail.send_mail_status !== MAIL_STATUS.PENDING
    })

    try {
      const responseList = await postBatchApi(filteredMail)

      // TODO: fix check status จาก key อื่น หลังจาก merge กับ dev
      const isAllSuccess = Array.isArray(responseList) && (responseList.length > 0) && responseList.every(r => r.message === STATUS.SUCCESS)

      setSendMailStatus((isAllSuccess) ? STATUS.SUCCESS : STATUS.ERROR)
    } catch (error) {
      console.log("error", error);
      setSendMailStatus(STATUS.ERROR);
    } finally {
      swalClose();
    }
  }

  const getTextColor = useCallback((row) => {
    if (!row.email) return 'red'

    if (row.send_mail_status === MAIL_STATUS.PENDING) return 'lightgrey'

    return 'inherit'
  }, [])

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle
        style={style.dialogColor}
      >
        ยืนยันการส่งอีเมล
        <MarkEmailReadIcon color="primary" className="ml-2" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Paper elevation={0} sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell> รายการเลขที่ใบแจ้งหนี้ </TableCell>
                    <TableCell> ชื่อผู้ใช้บริการ </TableCell>
                    <TableCell> อีเมล </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    rowSelectedList.map((row) => (
                      <TableRow
                        key={`invoice-${row._id}`}
                        sx={{
                          '& td': { color: getTextColor(row) },
                        }}
                      >
                        <TableCell sx={{ minWidth: 120, maxWidth: 150 }}>
                          {row.invoice_no}
                        </TableCell>
                        <TableCell sx={{ maxWidth: 170 }}>
                          {row.so_name}
                        </TableCell>
                        <TableCell sx={{ minWidth: 150 }} >
                          {row.email}
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <Paper className="w-full flex justify-end mt-2" elevation={0}>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                columnGap={2}
              >
                <Typography variant="caption" color="red" >
                  * ตัวอักษรสีแดงคือไม่มีอีเมล
                </Typography>
                <Typography variant="caption" color="lightgrey" >
                  * ตัวอักษรสีเทาคือกำลังส่ง
                </Typography>
              </Stack>
            </Paper>
          </Paper>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        style={style.dialogColor}
      >
        <Button onClick={() => confirmSendMail(rowSelectedList)}>
          ยืนยัน
        </Button>
        <Button onClick={() => onClose()} color="error">
          ยกเลิก
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const style = {
  dialogColor: {
    backgroundColor: '#fafafa',
  }
}
